import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription }   from 'rxjs/Subscription';
import { MenuStatus, Menu } from '../../models/Menu';
import { Subject } from 'rxjs/Subject';
import { MenuService } from '../../services/MenuService';
import { UserService } from '../../../user/services/UserService';
import { SessionService } from '../../../user/services/SessionService';
import { User } from '../../../user/models/User';
import { Router } from '@angular/router';
import { HolidayService } from '../../../../../holiday/services/HolidayService';
import { SessionStorageService } from '../../services';
import { AdminService } from '../../../../../common/modules/admin/services/AdminService';
import  {devEnv,localEnv,testEnv,stagingEnv,procEnv, demoEnv, bisHanoiEnv, bisHanoiDevEnv} from '../../../../config/config'

@Component({
    selector: 'main-menu',
    template: require('./MainMenuComponent.html'),
    styles: [require('./MainMenuComponent.sass')],
})

export class MainMenuComponent implements OnInit, OnDestroy {
    @Input() module: string;
    private menuList: Menu[];
    private subMenuList: Menu[];
    private parent: any;
    message:        string;
    messageType:    string;
    private userData: User;
	private hostName: string;
    private menuStatus: boolean;
    private menuStatusChanged = new Subject<boolean>();
    private subscription: Subscription;
    private menuSubscription: Subscription;
    private userMenuClassVisible = 'menu-list-visible';
   
    constructor(
        private menuService: MenuService,
        private router: Router,
        private holidayService: HolidayService,
        private userService: UserService,
        private sessionService: SessionService,
        private sessionStorageService: SessionStorageService,
        private adminService: AdminService
    ) {
    }
    
    ngOnInit() { 
        this.parent = new Object;     
        this.getSessionData()
        this.hostName = window.location.hostname;
        
        // Get main menu List
        this.menuList = this.getMainMenuList();
        //  Get sub menu list
        this.subMenuList = this.getSubMenuList();
        
        this.menuStatus = this.getMenuStatus();
        // Subscription to catch the session changed to change the menu list content
        this.subscription = this.userService.userDataChanged$.subscribe(
            user => {
                this.onSessionChanged(user);
            }
        );
    }

    checkAccountIsVasParent(){
        return this.sessionStorageService.getData<boolean>('isVasParent');
    }

    ngOnDestroy() {
        // Destroy the subscription for session changes
        this.subscription.unsubscribe();
    }

    /**
     * Action that fired when the session change event is catched.
     * Update the userData & the menuList.
     */
    private onSessionChanged(user: User) {
        //TO DO: update menu content when session changed
        this.userData = user;
        // Get Menu List
        this.menuList = this.getMainMenuList();
        this.subMenuList = this.getSubMenuList();
    }

    private onMenuStatusChanged() {
        this.menuStatus = this.getMenuStatus();
    }

    private getMenuStatus() {
        if( document.URL === `http://${devEnv.services}/` ||
            document.URL === `http://${localEnv.services}/` ||
            document.URL === `http://${testEnv.services}/` ||
            document.URL === `http://${bisHanoiEnv.services}/` ||
            document.URL === `http://${bisHanoiDevEnv.services}/` ||
            document.URL === `http://${stagingEnv.services}/` ||
            document.URL === `https://${procEnv.services}/` ||
            document.URL === `http://${demoEnv.services}/` 
        ) {
            return false
        }
        else {
            return true
        }
    }

    /**
     * Return a module 's menu list content for the main menu.
     * Return login main menu list if no user data is detected.
     * @returns {Menu[]|[]} - module's menu list or empty list.
     */
    private getMainMenuList() {
        let menuList: Menu[] = [];
        if(!this.userData && (this.hostName === procEnv.holiday
            || this.hostName === devEnv.holiday
            || this.hostName === localEnv.holiday
            || this.hostName === bisHanoiEnv.holiday
            || this.hostName === bisHanoiDevEnv.holiday
            || this.hostName === testEnv.holiday
            || this.hostName === stagingEnv.holiday
            || this.hostName === demoEnv.holiday)
        ) 
        {
            menuList = this.menuService.getMenuList('hol-login')
        }

        else if(!this.userData) {
            menuList = this.menuService.getMenuList('login-main');
        }
        else {
            menuList = this.menuService.getMenuList(this.module + '-main');
        }

        return menuList;
    }

    /**
     * Return a module 's SUB menu list content for the main menu.
     * Return login main menu list if no user data is detected.
     * @returns {Menu[]|[]} - module's menu list or empty list.
     */
    private getSubMenuList() {
        return this.menuService.getMenuList(this.module + '-sub');
    }

    toLogOut() {
        this.userData = this.userService.getUserSessionData();
        this.deleteSession();
    }
        /**
     * Delete user session data.
     */

    private deleteSession() {
        this.sessionService.deleteSession()
            .subscribe(
                complete => {
                    // Clear user session
                    this.userService.clearUserSessionData();
                    this.adminService.clearInterSession();

                    // Fire user session data changed event
                    this.userService.userDataChanged(null);

                    // Redirect to desired URL                    
                    if(Object.values(devEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `http://${devEnv.services}`;
                    }
                    else if(Object.values(testEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `http://${testEnv.services}`;
                    }
                    else if(Object.values(bisHanoiEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `http://${bisHanoiEnv.services}`;
                    }
                    else if(Object.values(bisHanoiDevEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `http://${bisHanoiDevEnv.services}`;
                    }
                    else if(Object.values(stagingEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href =  `https://${stagingEnv.services}`;
                    }
                    else if(Object.values(procEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `https://${procEnv.services}`;
                    }
                    else if(Object.values(demoEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `http://${demoEnv.services}`;
                    }
                    else{
                        return window.location.href = `http://${localEnv.services}`;
                    }
                },
            );
    }

    getSessionData() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userData = user
                    
                    if(this.userData.role !== 'system' && this.userData.role !== 'manager') {
                        this.getParent();
                    }
                        
                }
            )
    }

    toHomePage() {
        // Redirect to desired URL
        if(this.userData.role === 'parent' || this.parent.type === 'vas'){                   
            if(Object.values(devEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${devEnv.services}/parents`;
            }
            else if(Object.values(testEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${testEnv.services}/parents`;
            }
            else if(Object.values(bisHanoiEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${bisHanoiEnv.services}/parents`;
            }
            else if(Object.values(bisHanoiDevEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${bisHanoiDevEnv.services}/parents`;
            }
            else if(Object.values(stagingEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `https://${stagingEnv.services}/parents`;
            }
            else if(Object.values(procEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `https://${procEnv.services}/parents`;
            }
            else if(Object.values(demoEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${demoEnv.services}/parents`;
            }
            else{
                return window.location.href = `http://${localEnv.services}/parents`;
            }
        } 
        // Redirect to desired URL
        if(this.userData.role === 'hol-parent' || this.parent.type === 'other'){                   
            if(Object.values(devEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${devEnv.services}/other-parents`;
            }
            else if(Object.values(testEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${testEnv.services}/other-parents`;
            }
            else if(Object.values(bisHanoiEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${bisHanoiEnv.services}/other-parents`;
            }
            else if(Object.values(bisHanoiDevEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${bisHanoiDevEnv.services}/other-parents`;
            }
            else if(Object.values(stagingEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `https://${stagingEnv.services}/other-parents`;
            }
            else if(Object.values(procEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `https://${procEnv.services}/other-parents`;
            }
            else if(Object.values(demoEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${demoEnv.services}/other-parents`;
            }
            else{
                return window.location.href = `http://${localEnv.services}/other-parents`;
            }
        } 
        if(!this.userData && !this.parent){                   
            if(Object.values(devEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${devEnv.services}`;
            }
            else if(Object.values(testEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${testEnv.services}`;
            }
            else if(Object.values(bisHanoiEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${bisHanoiEnv.services}`;
            }
            else if(Object.values(bisHanoiDevEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${bisHanoiDevEnv.services}`;
            }
            else if(Object.values(stagingEnv).indexOf(this.hostName) !== -1){
                return window.location.href =  `https://${stagingEnv.services}`;
            }
            else if(Object.values(procEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `https://${procEnv.services}`;
            }
            else if(Object.values(demoEnv).indexOf(this.hostName) !== -1){
                return window.location.href = `http://${demoEnv.services}`;
            }
            else{
                return window.location.href = `http://${localEnv.services}`;
            }
        } 
    }

    toRegister() {
        if(this.hostName === procEnv.holiday
            || this.hostName === devEnv.holiday
            || this.hostName === localEnv.holiday
            || this.hostName === bisHanoiEnv.holiday
            || this.hostName === bisHanoiDevEnv.holiday
            || this.hostName === demoEnv.holiday) 
        {
            this.router.navigateByUrl('/hol-register');
        }
        else {
            this.router.navigate(['/register'])
        }
    }

    toChangePassword() {
        if(this.hostName === procEnv.holiday
            || this.hostName === devEnv.holiday
            || this.hostName === localEnv.holiday
            || this.hostName === bisHanoiEnv.holiday
            || this.hostName === bisHanoiDevEnv.holiday
            || this.hostName === demoEnv.holiday) 
        {
            this.router.navigateByUrl('/hol-change-password');
        }
        else {
            this.router.navigate(['/change-password'])
        }
    }
    menuStatusDataChanged(menu: boolean) {
        this.menuStatusChanged.next(menu);
    }

    private getParent() {
        this.holidayService.getParent()
            .subscribe(
                (parent:any) => {
                    this.parent = parent;

                    if(this.parent.status === "fill-info") {
                        this.router.navigate(['/profile/add-parent'])
                    }
                    else if(this.parent.status == "full") {
                        this.router.navigate(['/booking/students'])
                    }
                    else {
                        this.router.navigate(['/add-student'])
                       
                    }
                },
                (error:any) => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }

    toProfile(){
        if (this.hostName === procEnv.holiday
            || this.hostName === devEnv.holiday
            || this.hostName === localEnv.holiday
            || this.hostName === bisHanoiEnv.holiday
            || this.hostName === bisHanoiDevEnv.holiday
            || this.hostName === demoEnv.holiday) {
            this.router.navigateByUrl('/profile/edit-parent');
        }
        else {
            this.router.navigate(['/profile/edit-parent'])
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/modules/core/components/main-menu/MainMenuComponent.ts